import DosyaBilgileri from "./parser/DosyaBilgileri";
import Vekil from "./parser/Vekil";
import Taraf from "./parser/Taraf";
import Args from "./parser/Args";
import Ilam from "./parser/Ilam";
import Cek from "./parser/Ilamsiz/Cek";
import Senet from "./parser/Ilamsiz/Senet";
import Police from "./parser/Ilamsiz/Police";
import Kontrat from "./parser/Ilamsiz/Kontrat";
import Diger from "./parser/Ilamsiz/Diger";
import AlacakKalem from "./parser/AlacakKalem";
import TarafKisi from "./parser/TarafKisi";
import TarafKurum from "./parser/TarafKurum";
import TakipInjectable from "./parser/TakipInjectable";
import {DosyaFormDataInterface} from "./DosyaFormDataInterface";
import app from "@/main";
import {Mixins} from "@/plugins/uyap-plugin/takip_ac/Mixins";

export default class TakipXmlParser extends TakipInjectable{
    toplamTakibeEsasMiktar: number = 0;
    formData !: DosyaFormDataInterface;
    dosyaNode: HTMLUnknownElement | null = null;
    ilamliList: Ilam[] = [];
    cekList: Cek[] = [];
    senetList: Senet[] = [];
    policeList: Police[] = [];
    kontratList: Kontrat[] = [];
    digerList: Diger[] = [];
    //Base64 String Array
    icraDosyaBilgileri !: DosyaBilgileri;
    vekilList: Vekil[] = [];
    tarafList: Array<TarafKisi | TarafKurum> = [];
    tahsilatList: any[] = [];
    args: Args = new Args();
    hash: string = "";
    harcMasrafToplam: number = 0;
    hashObj: any;
    ilamSorgusu = {
        status: true,
        message: ""
    }
    alacakKalemParaBirimleri: string[] = [];

    static fromJson(jsonData: any): TakipXmlParser {
        try{
            let parser = new TakipXmlParser();
            parser.dosyaNode = jsonData.dosyaNode;
            parser.formData = jsonData.formData;
            parser.toplamTakibeEsasMiktar = jsonData.toplamTakibeEsasMiktar;

            parser.ilamliList = jsonData.ilamliList.map((ilam: Ilam) => {
                return Ilam.fromJson(ilam);
            });
            parser.cekList = jsonData.cekList.map((cek: Cek) => {
                return Cek.fromJson(cek);
            });
            parser.senetList = jsonData.senetList.map((senet: Senet) => {
                return Senet.fromJson(senet);
            });
            parser.policeList = jsonData.policeList.map((police: Police) => {
                return Police.fromJson(police);
            });
            parser.kontratList = jsonData.kontratList.map((kontrat: Kontrat) => {
                return Kontrat.fromJson(kontrat);
            });
            parser.digerList = jsonData.digerList.map((diger: Diger) => {
                return Diger.fromJson(diger);
            });
            parser.vekilList = jsonData.vekilList.map((vekil: Vekil) => {
                return Vekil.fromJson(vekil);
            });
            parser.tarafList = jsonData.tarafList.map((taraf: any) => {
                return Taraf.fromJson(taraf);
            })

            parser.icraDosyaBilgileri = DosyaBilgileri.fromJson(jsonData.icraDosyaBilgileri);

            parser.tahsilatList     = jsonData.tahsilatList;
            parser.dayanaklar       = jsonData.dayanaklar;
            parser.dayanaklarObject = jsonData.dayanaklarObject;
            parser.vekaletObject    = jsonData.vekaletObject;
            parser.vekalet          = jsonData.vekalet;
            parser.args             = Args.fromJson(jsonData.args);
            parser.hash             = jsonData.hash;
            parser.hashObj          = jsonData.hashObj;

            return  parser;
        }catch (e) {
            console.error("TakipXMLPARSER fromJson ERROR",e);
            throw new Error(e.message);
        }

    }

    static async parse(dosyaNode: any, formData: any): Promise<TakipXmlParser> {
        try {
            let parser = new TakipXmlParser();
            parser.dosyaNode = dosyaNode;
            parser.formData = formData;

            await app.$store.dispatch("getKurlarMerkezBankasi");
            if (parser.dosyaNode) {
                await parser.setEvraklar(parser.dosyaNode);
                await parser.setDayanakFromAlacakBelgePath();
                parser.icraDosyaBilgileri = await DosyaBilgileri.parse(parser.dosyaNode, parser.formData);
                parser.args.setIcraproXmliMi(parser.icraDosyaBilgileri.isIcraProXml());
                for (const node of parser.dosyaNode.querySelectorAll('vekilkisi')) {
                    let vekil = await Vekil.parse(node);
                    if (vekil)
                        parser.vekilList.push(vekil);
                }
                for (const node of parser.dosyaNode.querySelectorAll('taraf')) {
                    parser.tarafList.push(
                        await Taraf.parse(node, parser.vekilList, parser.formData)
                    )
                }
                parser.setBelgeler();
                parser.takibeEsasMiktarTopla();
                parser.setDosyaAdi();

                //Hata kontrolleri
                const kimlikCakismaMesaji = parser.alacakliIleBorcluKimlikCakisiyorMu();
                if (kimlikCakismaMesaji)
                    return Promise.reject({message: kimlikCakismaMesaji});
                const ayniRolKimlikTekrariMesaji = parser.ayniRolIcindeKimlikTekrariVarMi();
                if (ayniRolKimlikTekrariMesaji)
                    return Promise.reject({message: ayniRolKimlikTekrariMesaji});
                if (!parser.alacakliVarmi())
                    return Promise.reject({message: "Dosya alacaklı taraf bulunamadı lütfen kontrol ediniz."});
                if (!parser.borcluVarmi())
                    return Promise.reject({message: "Dosyada borçlu taraf türü hatalı seçilmiştir. Lütfen kontrol ediniz."});
                if (parser.tahsilatVarmi())
                    return Promise.reject({message: "XML'de Tahsilat Bulundu!"})
                parser.generateXmlHash();
                console.log("TO UYAP JSON", parser.toUyapJson());
                return Promise.resolve(parser);
            } else {
                return Promise.reject({message: "Lütfen dosya yükleyiniz."})
            }
        } catch (e) {
            console.error("TakipXML PARSER ERROR", e);
            return Promise.reject(e);
        }

    }

    isIlamli(): boolean {
        return this.ilamliList.length > 0;
    }

    /**
     * Alacaklı tarafları metin formatında döndürür
     */
    getAlacakliText(): string {
        const alacaklilar = this.tarafList?.filter((taraf) => taraf?.tarafSifati?.rolID === 21) || [];
        const alacakliText = alacaklilar
            .map((alacakli) => {
                if (alacakli?.kisiMi) {
                    if (alacakli.adSoyad) {
                        return alacakli.adSoyad;
                    }
                    const adi = alacakli.temelBilgileri?.adi ?? '';
                    const soyadi = alacakli.temelBilgileri?.soyadi ?? '';
                    const fullName = `${adi} ${soyadi}`.trim();
                    return fullName || '-';
                }
                return (
                    alacakli?.temelBilgileri?.kurumAdi ??
                    alacakli?.kurumAdi ??
                    alacakli?.adSoyad ??
                    '-'
                );
            })
            .filter(Boolean)
            .join(', ');
        return alacakliText || '-';
    }

    /**
     * Borçlu tarafları metin formatında döndürür
     */
    getBorcluText(): string {
        const borclular = this.tarafList?.filter((taraf) => taraf?.tarafSifati?.rolID !== 21) || [];
        const borcluText = borclular
            .map((borclu) => {
                if (borclu?.kisiMi) {
                    if (borclu.adSoyad) {
                        return borclu.adSoyad;
                    }
                    const adi = borclu.temelBilgileri?.adi ?? '';
                    const soyadi = borclu.temelBilgileri?.soyadi ?? '';
                    const fullName = `${adi} ${soyadi}`.trim();
                    return fullName || '-';
                }
                return (
                    borclu?.temelBilgileri?.kurumAdi ??
                    borclu?.kurumAdi ??
                    borclu?.adSoyad ??
                    '-'
                );
            })
            .filter(Boolean)
            .join(', ');
        return borcluText || '-';
    }

    /**
     * Borçlu vekillerini metin formatında döndürür
     * @param externalVekilList Dışarıdan verilen vekil listesi (opsiyonel)
     */
    getVekilText(externalVekilList?: Array<{ borcluVekiliMi: boolean; adSoyad?: string; ad?: string; soyad?: string }>): string {
        let vekiller: Array<{ borcluVekiliMi: boolean; adSoyad?: string; ad?: string; soyad?: string }> = [];

        if (this.vekilList && this.vekilList.length > 0) {
            vekiller = this.vekilList.filter((vekil) => vekil.borcluVekiliMi === true);
        }

        if (vekiller.length === 0 && externalVekilList) {
            vekiller = externalVekilList.filter((vekil) => vekil.borcluVekiliMi === true);
        }

        const vekilText = vekiller
            .map((vekil) => {
                return vekil.adSoyad || `${vekil.ad || ''} ${vekil.soyad || ''}`.trim() || '-';
            })
            .filter(Boolean)
            .join(', ');
        return vekilText || '-';
    }

    /**
     * IBAN metnini döndürür
     * @param ibanTercihi IBAN tercihi (Avukat veya Müvekkil)
     * @param avukatIban Avukat IBAN'ı (opsiyonel)
     */
    getIbanText(ibanTercihi?: string, avukatIban?: string): string {
        if (!ibanTercihi) return '-';

        // IbanTercihiEnum.Avukat = 'Avukat' veya '1'
        // @ts-ignore
        if (ibanTercihi === 'Avukat' || ibanTercihi === '1' || ibanTercihi === 1) {
            return avukatIban || '-';
        }

        // IbanTercihiEnum.Muvekkil = 'Müvekkil' veya '2'
        // @ts-ignore
        if (ibanTercihi === 'Müvekkil' || ibanTercihi === '2' || ibanTercihi === 2) {
            const alacaklilar = this.tarafList?.filter((taraf) => taraf?.tarafSifati?.rolID === 21) || [];
            const muvekkilIban = alacaklilar.find(
                (alacakli) => alacakli.hesapBilgisi?.ibanNumarasi,
            )?.hesapBilgisi?.ibanNumarasi;
            return muvekkilIban || '-';
        }

        return '-';
    }

    /**
     * Toplam takibe esas miktarı formatlanmış string olarak döndürür
     */
    getToplamTakibeEsasMiktarText(): string {
        if (!this.toplamTakibeEsasMiktar) return '-';
        try {
            return new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
            }).format(this.toplamTakibeEsasMiktar);
        } catch (e) {
            console.error('Currency formatting error:', e);
            return '-';
        }
    }

    getIlamBilgileri(): Ilam {
        return this.ilamliList[0];
    }

    setDosyaAdi() {
        if (this.icraDosyaBilgileri.dosyaBelirleyici.name == "") {
            this.tarafList.forEach((taraf) => {
                if (taraf.isKurum())
                    this.icraDosyaBilgileri.dosyaBelirleyici.name += "(" + taraf.tarafSifati.rolAdi + " : " + (taraf.temelBilgileri.kurumAdi || "").trim() + " )"
                else
                    this.icraDosyaBilgileri.dosyaBelirleyici.name += "(" + taraf.tarafSifati.rolAdi + " : " + (taraf.temelBilgileri.adi || "").trim() + " " + (taraf.temelBilgileri.soyadi || "").trim() + " )"
            })
        }
    }

    tahsilatVarmi(): boolean {
        let result: boolean = false;
        this.getIlamsizList().forEach((ilamsiz) => {
            if (ilamsiz.alacakKalemleri.filter((alacakKalemi: any) => app.$uyapHelper.turkishToLower(alacakKalemi.temelBilgileri.aciklama).indexOf('tahsilat') > -1).length > 0) {
                result = true;
            }
        })
        return result;
    }

    alacakliVarmi(): boolean {
        return this.tarafList.find(x => x.isAlacakli() && x.takipeDahilEt) != undefined;
    }

    borcluVarmi(): boolean {
        return this.tarafList.find(x => x.isBorclu() && x.takipeDahilEt) != undefined;
    }

    /**
     * UYAP taraf sorgulamasında kullanılan kimlik / ad anahtarlarına göre: aynı TCKN / VKN / MERSİS / DETSİS / kurum adı
     * hem alacaklı (21) hem borçlu (22) rollerinde ise XML'in düzeltilmesi gerekir.
     */
    private static normalizeKurumVkn(value: string): string | null {
        const d = Mixins.onlyDigit(value);
        return d.length === 10 ? d : null;
    }

    private static normalizeKurumMersis(value: string): string | null {
        const d = Mixins.onlyDigit(value);
        return d.length >= 10 ? d : null;
    }

    private static normalizeKurumDetsis(value: string): string | null {
        const d = Mixins.onlyDigit(value);
        return d.length >= 5 ? d : null;
    }

    /** KurumSorgulama kurumAdi ile uyumlu: trim, boşluk birleştirme, Türkçe karakter-normalize karşılaştırma. */
    private static normalizeKurumAdiKarsilastirma(taraf: TarafKisi | TarafKurum): string | null {
        if (!taraf.isKurum()) return null;
        const raw = (taraf.temelBilgileri.kurumAdi || taraf.kurumAdi || "").trim().replace(/\s+/g, " ");
        if (raw.length < 3) return null;
        return app.$uyapHelper.turkishToLower(raw);
    }

    private alacakliIleBorcluKimlikCakisiyorMu(): string | null {
        const alacakliTc = new Set<string>();
        for (const taraf of this.tarafList) {
            if (!taraf.isKisi() || !taraf.isAlacakli()) continue;
            const tc = Mixins.onlyDigit(taraf.temelBilgileri.tcKimlikNo);
            if (Mixins.checkTcNum(tc))
                alacakliTc.add(tc);
        }
        for (const taraf of this.tarafList) {
            if (!taraf.isKisi() || !taraf.isBorclu()) continue;
            const tc = Mixins.onlyDigit(taraf.temelBilgileri.tcKimlikNo);
            if (Mixins.checkTcNum(tc) && alacakliTc.has(tc)) {
                return "Dosya hatalı: T.C. kimlik numarası (" + tc + ") hem alacaklı hem borçlu şahıs olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz.";
            }
        }

        const alacakliVergi = new Set<string>();
        const alacakliMersis = new Set<string>();
        const alacakliDetsis = new Set<string>();
        const alacakliKurumAdi = new Set<string>();
        for (const taraf of this.tarafList) {
            if (!taraf.isKurum() || !taraf.isAlacakli()) continue;
            const vkn = TakipXmlParser.normalizeKurumVkn(taraf.temelBilgileri.vergiNo);
            const mersis = TakipXmlParser.normalizeKurumMersis(taraf.temelBilgileri.mersisNo);
            const detsis = TakipXmlParser.normalizeKurumDetsis(taraf.temelBilgileri.detsisNo);
            const kurumAdiKey = TakipXmlParser.normalizeKurumAdiKarsilastirma(taraf);
            if (vkn) alacakliVergi.add(vkn);
            if (mersis) alacakliMersis.add(mersis);
            if (detsis) alacakliDetsis.add(detsis);
            if (kurumAdiKey) alacakliKurumAdi.add(kurumAdiKey);
        }
        for (const taraf of this.tarafList) {
            if (!taraf.isKurum() || !taraf.isBorclu()) continue;
            const vkn = TakipXmlParser.normalizeKurumVkn(taraf.temelBilgileri.vergiNo);
            const mersis = TakipXmlParser.normalizeKurumMersis(taraf.temelBilgileri.mersisNo);
            const detsis = TakipXmlParser.normalizeKurumDetsis(taraf.temelBilgileri.detsisNo);
            if (vkn && alacakliVergi.has(vkn)) {
                return "Dosya hatalı: Vergi numarası (" + vkn + ") hem alacaklı hem borçlu kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz.";
            }
            if (mersis && alacakliMersis.has(mersis)) {
                return "Dosya hatalı: MERSİS numarası (" + mersis + ") hem alacaklı hem borçlu kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz.";
            }
            if (detsis && alacakliDetsis.has(detsis)) {
                return "Dosya hatalı: DETSİS numarası (" + detsis + ") hem alacaklı hem borçlu kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz.";
            }
            const kurumAdiKey = TakipXmlParser.normalizeKurumAdiKarsilastirma(taraf);
            if (kurumAdiKey && alacakliKurumAdi.has(kurumAdiKey)) {
                const gorunenAd = (
                    (taraf.temelBilgileri.kurumAdi || taraf.kurumAdi || "").trim().replace(/\s+/g, " ")
                );
                return (
                    "Dosya hatalı: Kurum adı (\"" +
                    gorunenAd +
                    "\") hem alacaklı hem borçlu kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                );
            }
        }

        return null;
    }

    /**
     * Aynı rol (alacaklı veya borçlu) içinde tekrarlayan TCKN / VKN / MERSİS / DETSİS / kurum adı.
     */
    private ayniRolIcindeKimlikTekrariVarMi(): string | null {
        const alacakliMesaj = this.ayniRolIcindeKimlikTekrariMesaji("alacaklı", (t) => t.isAlacakli());
        if (alacakliMesaj) return alacakliMesaj;
        return this.ayniRolIcindeKimlikTekrariMesaji("borçlu", (t) => t.isBorclu());
    }

    private ayniRolIcindeKimlikTekrariMesaji(
        rolEtiketi: string,
        includeTaraf: (t: TarafKisi | TarafKurum) => boolean,
    ): string | null {
        const seenTc = new Set<string>();
        const seenVkn = new Set<string>();
        const seenMersis = new Set<string>();
        const seenDetsis = new Set<string>();
        const seenKurumAdi = new Set<string>();

        for (const taraf of this.tarafList) {
            if (!includeTaraf(taraf)) continue;

            if (taraf.isKisi()) {
                const tc = Mixins.onlyDigit(taraf.temelBilgileri.tcKimlikNo);
                if (!Mixins.checkTcNum(tc)) continue;
                if (seenTc.has(tc)) {
                    return (
                        "Dosya hatalı: T.C. kimlik numarası (" +
                        tc +
                        ") birden fazla " +
                        rolEtiketi +
                        " şahıs olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                    );
                }
                seenTc.add(tc);
                continue;
            }

            if (taraf.isKurum()) {
                const vkn = TakipXmlParser.normalizeKurumVkn(taraf.temelBilgileri.vergiNo);
                if (vkn) {
                    if (seenVkn.has(vkn)) {
                        return (
                            "Dosya hatalı: Vergi numarası (" +
                            vkn +
                            ") birden fazla " +
                            rolEtiketi +
                            " kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                        );
                    }
                    seenVkn.add(vkn);
                }
                const mersis = TakipXmlParser.normalizeKurumMersis(taraf.temelBilgileri.mersisNo);
                if (mersis) {
                    if (seenMersis.has(mersis)) {
                        return (
                            "Dosya hatalı: MERSİS numarası (" +
                            mersis +
                            ") birden fazla " +
                            rolEtiketi +
                            " kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                        );
                    }
                    seenMersis.add(mersis);
                }
                const detsis = TakipXmlParser.normalizeKurumDetsis(taraf.temelBilgileri.detsisNo);
                if (detsis) {
                    if (seenDetsis.has(detsis)) {
                        return (
                            "Dosya hatalı: DETSİS numarası (" +
                            detsis +
                            ") birden fazla " +
                            rolEtiketi +
                            " kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                        );
                    }
                    seenDetsis.add(detsis);
                }
                const kurumAdiKey = TakipXmlParser.normalizeKurumAdiKarsilastirma(taraf);
                if (kurumAdiKey) {
                    if (seenKurumAdi.has(kurumAdiKey)) {
                        const gorunenAd = (
                            (taraf.temelBilgileri.kurumAdi || taraf.kurumAdi || "").trim().replace(/\s+/g, " ")
                        );
                        return (
                            "Dosya hatalı: Kurum adı (\"" +
                            gorunenAd +
                            "\") birden fazla " +
                            rolEtiketi +
                            " kurum olarak tanımlanmış. Lütfen XML dosyanızı düzeltiniz."
                        );
                    }
                    seenKurumAdi.add(kurumAdiKey);
                }
            }
        }

        return null;
    }

    getIlamsizList(): any[] {
        //@ts-ignore
        let ilamsizList = [].concat(this.cekList).concat(this.senetList).concat(this.policeList).concat(this.kontratList).concat(this.digerList);
        if (this.formData.alacakKalemIslemisFaizlerToplansin) {
            return this.alacakKalemIslemisFaizleriTopla(ilamsizList);
        }
        return ilamsizList;
    }

    getIlamliList(): any[]{
        if (this.formData.alacakKalemIslemisFaizlerToplansin) {
            let aa = this.alacakKalemIslemisFaizleriTopla(this.ilamliList);
            return aa;
        }
        return this.ilamliList;
    }

    alacakKalemIslemisFaizleriTopla(ilamsizList: any[]): any[] {
        //console.log("alacakKalemIslemisFaizleriTopla ilamsizList",ilamsizList)
        ilamsizList.forEach(ilamsiz => {
            let alacakKalemleri: any[] = [];
            let toplananAlacakKalemi: any = null;
            ilamsiz.alacakKalemleri.forEach((alacakKalemi: AlacakKalem) => {
                //console.log("alacak kalemi",alacakKalemi)
                //İşlemiş faiz 6
                if (alacakKalemi.temelBilgileri.selectedAlacakKalemKodu.alacakKalemKod == "6" || alacakKalemi.temelBilgileri.selectedAlacakKalemKodu.alacakKalemKod == "7183") {
                    if (!toplananAlacakKalemi)
                        toplananAlacakKalemi = alacakKalemi;
                    else
                        toplananAlacakKalemi.temelBilgileri.alacakTutari = (parseFloat(toplananAlacakKalemi.temelBilgileri.alacakTutari) + parseFloat(alacakKalemi.temelBilgileri.alacakTutari)).toFixed(2);
                } else {
                    if(toplananAlacakKalemi){
                        toplananAlacakKalemi.temelBilgileri.aciklama = "İşlemiş Faiz";
                        toplananAlacakKalemi.temelBilgileri.detayliAciklama = "İşlemiş Faiz";
                        alacakKalemleri.push(toplananAlacakKalemi);
                        toplananAlacakKalemi = null;
                    }
                    alacakKalemleri.push(alacakKalemi);
                }
            })
            if (toplananAlacakKalemi) {
                toplananAlacakKalemi.temelBilgileri.aciklama = "İşlemiş Faiz";
                toplananAlacakKalemi.temelBilgileri.detayliAciklama = "İşlemiş Faiz";
                alacakKalemleri.push(toplananAlacakKalemi);
            }
            ilamsiz.alacakKalemleri = alacakKalemleri;
        })
        return ilamsizList;
    }

    takibeEsasMiktarTopla() {
        this.alacakKalemParaBirimleriBul();
        this.toplamTakibeEsasMiktar = 0;
        this.alacakKalemiTopla(this.digerList);
        this.alacakKalemiTopla(this.cekList);
        this.alacakKalemiTopla(this.policeList);
        this.alacakKalemiTopla(this.kontratList);
        this.alacakKalemiTopla(this.senetList);
        this.alacakKalemiTopla(this.ilamliList);
    }

    alacakKalemParaBirimleriBul(){
        let alacakKalemleri: any[] = [];
        this.digerList.forEach((diger: any)=>{ alacakKalemleri  = alacakKalemleri .concat(diger.alacakKalemleri) });
        this.cekList.forEach((item: any)=>{ alacakKalemleri  = alacakKalemleri .concat(item.alacakKalemleri) });
        this.policeList.forEach((item: any)=>{ alacakKalemleri  = alacakKalemleri .concat(item.alacakKalemleri) });
        this.kontratList.forEach((item: any)=>{ alacakKalemleri  = alacakKalemleri .concat(item.alacakKalemleri) });
        this.senetList.forEach((item: any)=>{ alacakKalemleri  = alacakKalemleri .concat(item.alacakKalemleri) });
        this.ilamliList.forEach((item: any)=>{ alacakKalemleri  = alacakKalemleri .concat(item.alacakKalemleri) });
        alacakKalemleri .forEach((alacakKalemi: AlacakKalem)=>{
            let index= this.alacakKalemParaBirimleri.indexOf(alacakKalemi.temelBilgileri.selectedParaBirimi);
            if(index === -1){
                this.alacakKalemParaBirimleri.push(alacakKalemi.temelBilgileri.selectedParaBirimi);
            }
        })
    }

    alacakKalemiTopla(belgeList: any[]) {
        belgeList.forEach(belge => {
            let deleteKeyList: any[] = [];
            belge.alacakKalemleri.forEach((alacakKalemi: AlacakKalem, key: number) => {
                this.alacakKalemParaBirimleri.push(alacakKalemi.temelBilgileri.selectedParaBirimi);
                if (alacakKalemi === null) {
                    //tutar 0  esit veya kucukse null geliyor
                    deleteKeyList.push(key);
                } else {
                    if(alacakKalemi.temelBilgileri.selectedParaBirimi == "PRBRMTL"){
                        this.toplamTakibeEsasMiktar += parseFloat(alacakKalemi.temelBilgileri.alacakTutari)
                    }else{
                        if(this.alacakKalemParaBirimleri.length > 1 && alacakKalemi.temelBilgileri.kur != ""){
                            this.toplamTakibeEsasMiktar += parseFloat(alacakKalemi.temelBilgileri.alacakTutari) * parseFloat(alacakKalemi.temelBilgileri.kur)
                        }else if(alacakKalemi.temelBilgileri.kur == "" && alacakKalemi.dovizMi === true){
                            //console.log("alacakKalemi.temelBilgileri.selectedParaBirimi",alacakKalemi.temelBilgileri.selectedParaBirimi);
                            let selectedParaBirimiClean = alacakKalemi.temelBilgileri.selectedParaBirimi.replace("PRBRM","");
                            let todayKur = app.$store.state.kurlar.find((kur: any) => kur.code == selectedParaBirimiClean);
                           //console.log("todayKur FROM selectedParaBirimiClean",selectedParaBirimiClean,todayKur);
                            if(todayKur){
                                this.toplamTakibeEsasMiktar += parseFloat(alacakKalemi.temelBilgileri.alacakTutari) * parseFloat(todayKur?.banknote_selling)//banknote_selling
                                //console.log("alacakKalemi.temelBilgileri.alacakTutari  * "+todayKur?.banknote_selling);
                            }

                        }
                    }
                }
            });
            deleteKeyList.forEach(index => {
                console.log("DELETED AKALEMI INDEX", index);
                belge.alacakKalemleri.splice(index, 1);
            })

        })
    }

    async setDayanakFromAlacakBelgePath(): Promise<void> {
        try {
            let alacakBelgePath = Mixins.nullUndefCleaner((this.dosyaNode as HTMLUnknownElement).getAttribute("alacakbelge"));
            // alacakBelge="C:\Faturalar\MTS_CASE_OPENING_202201181077234757..pdf"
            if (alacakBelgePath != "") {
                console.log("alacakBelgePath", alacakBelgePath);
                let belge = await app.$imza.getFileFromLocalPath(alacakBelgePath);
                console.log("BELGEEEE ------", belge);
                let splited = alacakBelgePath.replace(/\\/g, "/").split("/");
                let fileName = splited[splited.length - 1];
                let evrak = {
                    data: belge.file,
                    mimeType: Mixins.findFileMimeType(fileName),
                    name: fileName
                };
                console.log("alacakBelge To Dayanak", evrak);
                this.dayanaklar.push(evrak);
            }
        } catch (e) {
            console.error("AlacakBelge Eklenemedi ", e);
        }
    }

    setBelgeler() {
        this.setIlamlar();
        this.setCekler();
        this.setSenetler();
        this.setPoliceler();
        this.setKontratlar();
        this.setDigerler();
    }


    setDigerler() {
        //UPDATE OK
        if (this.dosyaNode) {
            let nodeList = this.sekizinciMaddeyeOzelNodeBirlestir(this.dosyaNode.querySelectorAll('digerAlacak'));
            nodeList.forEach((node: any) => {
                this.digerList.push(
                    Diger.parse(node, this.args, this.tarafList)
                )
            });
            this.ilamsizSortArray(this.digerList);
        }
    }

    setKontratlar() {
        //UPDATE OK
        if (this.dosyaNode) {
            let nodeList = this.sekizinciMaddeyeOzelNodeBirlestirKontrat(this.dosyaNode.querySelectorAll('kontratkefil'));
            nodeList.forEach((node: any) => {
                this.kontratList.push(
                    Kontrat.parse(node, this.args, this.tarafList)
                )
            });
        }
    }

    setPoliceler() {
        //UPDATE OK
        if (this.dosyaNode) {
            let nodeList = this.sekizinciMaddeyeOzelNodeBirlestir(this.dosyaNode.querySelectorAll('police'));
            nodeList.forEach((node: any) => {
                this.policeList.push(
                    Police.parse(node, this.args, this.tarafList)
                )
            });
        }

    }

    setSenetler() {
        //UPDATE OK
        if (this.dosyaNode) {
            let nodeList = this.sekizinciMaddeyeOzelNodeBirlestir(this.dosyaNode.querySelectorAll('senet'));
            nodeList.forEach((node: any) => {
                this.senetList.push(
                    Senet.parse(node, this.args, this.tarafList)
                )
            });
            this.ilamsizSortArray(this.senetList);
        }
    }

    setCekler() {
        //UPDATE OK
        if (this.dosyaNode) {
            let nodeList = this.sekizinciMaddeyeOzelNodeBirlestir(this.dosyaNode.querySelectorAll('cek'));
            nodeList.forEach((node: any) => {
                this.cekList.push(
                    Cek.parse(node, this.args, this.tarafList)
                )
            });
            this.ilamsizSortArray(this.cekList);
        }
    }

    setIlamlar() {
        //UPDATE OK
        if (this.dosyaNode) {
            this.dosyaNode.querySelectorAll('ilam').forEach((node: any) => {
                this.ilamliList.push(
                    Ilam.parse(node, this.args, this.tarafList)
                )
            });
        }
    }


    ilamsizSortArray(ilamsizArray: any[]) {
        ilamsizArray.sort((a, b) => {
            if (typeof a.alacakTarihi == 'undefined' || typeof b.alacakTarihi == 'undefined' || a.alacakTarihi == null || b.alacakTarihi == null) {
                return 0;
            }
            let aDateArr = a.alacakTarihi.split('/');
            let bDateArr = b.alacakTarihi.split('/');

            if (aDateArr.length != 3 || bDateArr.length != 3) {
                return 0;
            }

            let aDate = new Date(aDateArr[2], aDateArr[1], aDateArr[0]);
            let bDate = new Date(bDateArr[2], bDateArr[1], bDateArr[0]);
            if (aDate > bDate) {
                return 1;
            }
            if (aDate < bDate) {
                return -1;
            }
            return 0;
        })
    }

    sekizinciMaddeyeOzelNodeBirlestirKontrat(nodeList: NodeListOf<Element>) {
        if (nodeList.length === 0) {
            return nodeList;
        }
        let firstNode = nodeList[0];
        nodeList.forEach((node, key) => {
            if (key > 0) {
                node.querySelectorAll("alacakKalemi").forEach(alacakKalemNode => {
                    if (firstNode) {
                        //@ts-ignore
                        firstNode.querySelector("kontrat").appendChild(alacakKalemNode);
                    }
                })
            }
        });
        return [firstNode];
    }

    paraBirimleriAyniMi(nodeList: NodeListOf<Element>){
        let tutarTurArray: any[] = [];
        nodeList.forEach((node, key) => {
            let tutarTur = node.getAttribute("tutartur");
            tutarTurArray.push(tutarTur);
        });
        return this.allEqual(tutarTurArray);
    }

    allEqual(arr: any[]) {
        if (!Array.isArray(arr)) return false;
        if (arr.length === 0) return false; // boş dizi için davranışı değiştirmek isterseniz true yapabilirsiniz

        const normalized = arr.map(v => {
            // Obje/array ise JSON stringine çevir, değilse olduğu gibi kullan
            if (v !== null && typeof v === 'object') return JSON.stringify(v);
            return v;
        });

        return new Set(normalized).size === 1;
    }

    sekizinciMaddeyeOzelNodeBirlestir(nodeList: NodeListOf<Element>) {
        //EUP-481 --
        if (nodeList.length > 0) {
            let firstNode = nodeList[0];
            let sekizinciMadde = firstNode.getAttribute("sekizincimadde");
            if (sekizinciMadde) {
                if (sekizinciMadde.trim() == "")
                    return nodeList;
                if(!this.paraBirimleriAyniMi(nodeList))
                    return nodeList;

                nodeList.forEach((node, key) => {
                    if (key > 0) {
                        if (node.getAttribute("sekizincimadde") == sekizinciMadde) {

                            if (
                                firstNode.nodeName == "SENET" ||
                                firstNode.nodeName == "KONTRAT" ||
                                firstNode.nodeName == "POLICE"

                            ) {
                                //@ts-ignore
                                let tutar = parseFloat(firstNode.getAttribute("belgeninTutari")) + parseFloat(node.getAttribute("belgeninTutari"));
                                firstNode.setAttribute("belgeninTutari", tutar.toString());
                            } else {
                                //@ts-ignore
                                let tutar = parseFloat(firstNode.getAttribute("tutar")) + parseFloat(node.getAttribute("tutar"));
                                firstNode.setAttribute("tutar", tutar.toString());
                            }

                            node.querySelectorAll("alacakKalemi").forEach(alacakKalemNode => {
                                firstNode.appendChild(alacakKalemNode);
                            })
                        }
                    }
                })
                //  let resultNode = document.createElement(firstNode.nodeName)
                return [firstNode]
            }
        }
        return nodeList;
    }


    generateXmlHash() {
        let hashObj: any = {
            taraflar: [],
            takibeEsasMiktar: this.toplamTakibeEsasMiktar,
        };
        this.tarafList.forEach(taraf => {
            if (taraf.isKisi()) {
                hashObj.taraflar.push({
                    ad: (taraf.temelBilgileri.adi || "").trim(),
                    soyad: (taraf.temelBilgileri.soyadi || "").trim(),
                    tcKimlikNo: (taraf.temelBilgileri.tcKimlikNo || "").trim(),
                    rolId: taraf.tarafSifati.rolID
                })
            }
            if (taraf.isKurum()) {
                hashObj.taraflar.push({
                    kurumadi: (taraf.temelBilgileri.kurumAdi || "").trim(),
                    vergino: (taraf.temelBilgileri.vergiNo || "").trim(),
                    mersisno: (taraf.temelBilgileri.mersisNo || "").trim(),
                    rolId: taraf.tarafSifati.rolID
                })
            }
        })
        this.hashObj = hashObj;
        this.hash = app.$uyapHelper.hash(hashObj)
    }

    toUyapTestJson() {
        let ilamsizList = this.getIlamsizList();
        let ilamliList = this.getIlamliList();
        let result = {
            IcraDosyaBilgileri: this.icraDosyaBilgileri.toUyapJson(),
            IlamliList: ilamliList.map((i) => i.toUyapJson()),
            IlamsizList: ilamsizList.map(x => x.toUyapJson()),
            TarafList: this.tarafList.map((i) => i.toUyapJson()),
            TahsilatList: this.tahsilatList.map((i) => i.toUyapJson()),
            IslemTuru: 'topluTakip'
        };
        return result;
    }

    toUyapJson() {
        let ilamsizList = this.getIlamsizList();
        let ilamliList = this.getIlamliList();
        let result = {
            IcraDosyaBilgileri: JSON.stringify(this.icraDosyaBilgileri.toUyapJson()),
            IlamliList: JSON.stringify(ilamliList.map((i) => i.toUyapJson())),
            IlamsizList: JSON.stringify(ilamsizList.map(x => x.toUyapJson())),
            TarafList: this.tarafList.map((i) => i.toUyapJson()),
            TahsilatList: JSON.stringify(this.tahsilatList.map((i) => i.toUyapJson())),
            IslemTuru: 'topluTakip'
        };
        return result;
    }
}
